import { assetsStatic } from 'constants/app';
import Image from 'global/Image';
import { useState } from 'react';
import styled from 'styled-components';
import color from '@deprecated-ui/_style/color';

export const ImagePlaceholder = styled.span`
  background-color: #3A645C;
  border-radius: 50%;
  color: ${color.light};
  display: flex;
  min-height: 20px;
  min-width: 20px;

  > small {
    font-family: 'Proxima Nova', sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 19px;
    margin: auto;
    text-align: center;
  }
`;

type CompanyIconProps = {
  symbol: string;
}

const CompanyIcon = ({ symbol }: CompanyIconProps) => {
  const [isIconAvailable, setIsIconAvailable] = useState(true);

  if (isIconAvailable) {
    return (
      <Image
        src={`${assetsStatic}/logos/companies/${symbol}.png`}
        alt={symbol}
        width={20}
        height={20}
        onError={() => setIsIconAvailable(false)}
      />
    );
  }

  return (
    <ImagePlaceholder>
      <small>{!!symbol && symbol.toUpperCase().slice(0, 1)}</small>
    </ImagePlaceholder>
  );
};

export default CompanyIcon;
